import moment from "moment"
import { StartUpperCase } from "./Format"
import { env } from "../../../../core/Env"

export const FeatureIdState = (name) =>{

    if (env() === 'sb') {
        return 'sb'
    }else if(env() === 'prod'){
        return 'prod'
    }else{
        let state = {
            dashboard:874,
            career_post:869,
            application_list:873,
        }
    
        return state[name]
    }
}

export const RoleState = (role_type) => {
    if (role_type === 'Super Admin' || role_type === 'Admin') {
        return [
            {id:FeatureIdState('dashboard'), feature_name:'dashboard', path:`${FeatureIdState('dashboard')}`, action:[]},
            {id:FeatureIdState('career_post'), feature_name:'career-post', path:`${FeatureIdState('career_post')}`, action:[1,3]},
            {id:FeatureIdState('application_list'), feature_name:'application-list', path:`${FeatureIdState('application_list')}`, action:[]},
        
        ]
    }else if(role_type === 'Regular User') {
        return [
            {id:FeatureIdState('dashboard'), feature_name:'dashboard', path:`${FeatureIdState('dashboard')}`, action:[1]},
            {id:FeatureIdState('career_post'), feature_name:'career_post', path:`${FeatureIdState('career_post')}`, action:[1],
                sub:[
                    {id:1, feature_name:'createpost', path:`${FeatureIdState('createpost')}->1`, action:[1,3]},
                ]
            },
            {id:FeatureIdState('application_list'), feature_name:'application-list', path:`${FeatureIdState('application_list')}`, action:[1],
                sub:[
                    {id:1, feature_name:'all', path:`${FeatureIdState('all')}->1`, action:[2]},
                ]
            },
            {id:FeatureIdState('general_maintenance'), feature_name:'general-maintenance', path:`${FeatureIdState('general_maintenance')}`, action:[],
                sub:[
                    {id:1, feature_name:'company-setup', path:`${FeatureIdState('general_maintenance')}->1`, action:[1, 3]},
                    {id:2, feature_name:'number-sequence', path:`${FeatureIdState('general_maintenance')}->2`, action:[1, 3]},
                    {id:3, feature_name:'master-list', path:`${FeatureIdState('general_maintenance')}->3`, action:[], 
                        sub_2:[
                            {id:1, feature_name:'department', path:`${FeatureIdState('general_maintenance')}->3->1`, action:[1, 3]},
                            {id:2, feature_name:'position', path:`${FeatureIdState('general_maintenance')}->3->2`, action:[1, 3]},
                            {id:3, feature_name:'user', path:`${FeatureIdState('general_maintenance')}->3->3`, action:[1, 3]},
                            {id:4, feature_name:'client', path:`${FeatureIdState('general_maintenance')}->3->4`, action:[1, 3]},
                        ]
                    },
                    {id:4, feature_name:'user-role', path:`${FeatureIdState('general_maintenance')}->4`, action:[3]},
                ]
            },
            {id:FeatureIdState('tool_categories'), feature_name:'tool-categories', path:`${FeatureIdState('tool_categories')}`, action:[]},
        ]
    }

}

export const FeatureState = (type, role_type) => {
    // action: 1 = Create, 2 = Read, 3 = Update, 4 = Download, 5 = Export, 
    
    let fs = RoleState(role_type)
    
    if (type === 'all') {
        return fs
    }else if (type === 'most-used-page' || type === 'usage-detailed') {
        const FlattenArrays = (data) => {
            let result = [];

            const processItem = (item, parentPath = '') => {
                result.push({ feature_name: item.feature_name, path: parentPath || item.path, action:item.action });

                // Check for nested sub arrays (sub, sub_2, sub_3, etc.)
                Object.keys(item).forEach(key => {
                    if (key.startsWith('sub')) {
                        item[key].forEach(subItem => {
                            processItem(subItem, `${parentPath || item.path}->${subItem.path.split('->').pop()}`);
                        });
                    }
                });
            };

            data.forEach(item => processItem(item));
            return result;
        };
        let res = FlattenArrays(fs)
        return res
    }else{
        const findFeature = (data, targetFeatureName) => {
            for (const i of data) {
                if (i.feature_name.toLowerCase() === targetFeatureName.toLowerCase()) {
                    return i
                }
                if (i.sub) {
                    const found_data = findFeature(i.sub, targetFeatureName)
                    if (found_data) return found_data
                }
                if (i.sub_2) {
                    const found_data = findFeature(i.sub_2, targetFeatureName)
                    if (found_data) return found_data
                }
            }
            return null
        }
        const filter = findFeature(fs, type)
        return filter
    }
}

export const getAllFeatureTask = (res_target, res_data) => {
    const actionMap = {
        1: "Create",
        // 2: "Read",
        3: "Update",
        4: "Download",
        5: "Export",
    };

    const result = [];

    res_target.forEach(item => {

        // Remove sub features (those containing "->")
        if (item.path.includes("->")) return;

        // group all items with same feature path
        const group = res_target.filter(v => v.path.startsWith(item.path));

        const sub = [];

        // Loop all children + self
        group.forEach(grp => {
            grp.action.forEach(action => {
                const matched = res_data.find(
                    rdc =>
                        rdc.feature_name === grp.feature_name &&
                        rdc.path === grp.path &&
                        rdc.action === action
                );

                sub.push({
                    to_do: `${actionMap[action]} ${StartUpperCase(grp.feature_name)}`,
                    count: matched ? matched.count : 0,
                });
            });
        });

        // Remove duplicates
        const unique = [];
        const map = new Set();
        sub.forEach(sub => {
            if (!map.has(sub.to_do)) {
                map.add(sub.to_do);
                unique.push(sub);
            }
        });

        if (unique.length > 0) {
            result.push({
                feature_name: item.feature_name,
                path: item.path,
                action: item.action,
                sub: unique,
            });
        }
    });

    return result
}

export const FetchingGraphDates = async(interval, sequence, order, date, quarter) => {

    let dates
    let datasets = {load: 'data', label: [], counts: []}

    if (interval === 'daily') {
        let nd = new Date(date)
        dates = [[`${date} 00:00:01`, `${date} 23:59:59`]]
        for (let i = 1; i < sequence; i++) {
            if (order === 'desc') {
                dates = [[`${moment(nd).subtract(i, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(nd).subtract(i, "days").format("MM-DD-YYYY")} 23:59:59`], ...dates]
            } else {
                dates = [...dates, [`${moment(nd).add(i, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(nd).add(i, "days").format("MM-DD-YYYY")} 23:59:59`]]
            }
        }
        datasets.label = dates.map(d => {
            let dd = new Date(d[0])
            return [`${moment(dd).format("ddd")}`, `${moment(dd).format("MMM D, YY")}` ]
        })
    } else if (interval === 'weekly') {
        let nd = new Date(date)
        let nextdate = order==='desc'?`${moment(nd).subtract(6, "days").format("MM-DD-YYYY")} 00:00:01`:`${moment(nd).add(6, "days").format("MM-DD-YYYY")} 23:59:59`
        dates = [order==='desc'?[nextdate, `${date} 23:59:59`]:[`${date} 00:00:01`, nextdate]]
        for (let i = 1; i < sequence; i++) {
            let parse_nd = new Date(nextdate)
            if (order === 'desc') {
                dates = [[`${moment(parse_nd).subtract(7, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).subtract(1, "days").format("MM-DD-YYYY")} 23:59:59`], ...dates]
                nextdate = `${moment(parse_nd).subtract(7, "days").format("MM-DD-YYYY")}`
            } else {
                dates = [...dates, [`${moment(parse_nd).add(1, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).add(7, "days").format("MM-DD-YYYY")} 23:59:59`]]
                nextdate = `${moment(parse_nd).add(7, "days").format("MM-DD-YYYY")} 23:59:59`
            }
        }
        
        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            let nd2 = new Date(d[1])
            return [`${moment(nd1).format("MMM D, YY")}`, `to`, ` ${moment(nd2).format("MMM D, YY")}` ]
        })
    } else if (interval === 'monthly') {
        let nd = new Date(date)
        dates = [[`${moment(nd).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(nd).endOf('month').format('MM-DD-YYYY')} 23:59:59`]];
        let nmonth = moment(nd).startOf('month')
        for (let i = 1; i < sequence; i++) {
            let parse_nm = new Date(nmonth)
            if (order === 'desc') {
                let m = moment(parse_nm).subtract(1, 'month')
                dates = [[`${moment(m).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(m).endOf('month').format('MM-DD-YYYY')} 23:59:59`], ...dates]
                nmonth = moment(m).startOf('month')
            } else {
                let m = moment(parse_nm).add(1, 'month')
                dates = [...dates, [`${moment(m).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(m).endOf('month').format('MM-DD-YYYY')} 23:59:59`]]
                nmonth = moment(m).startOf('month')
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            return [`Month`, `of`, `${moment(nd1).format("MMM, YY")}`]
        })
    } else if (interval === 'quarterly') {
        let d = new Date(date)
        let qrt = quarter === '1st' ? '01-01' : quarter === '2nd' ? '04-01' : quarter === '3rd' ? '07-01' : '10-01'
        let nd = new Date(`${qrt}-${moment(d).format('YYYY')}`)
        let nextdate = order==='desc'?`${moment(nd).add(2, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`:`${moment(nd).add(2, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`
        dates = [order==='desc'?[nextdate, `${moment(nd).format('MM-DD-YYYY')} 00:00:01`]:[`${moment(nd).format('MM-DD-YYYY')} 00:00:01`, nextdate]]
        
        for (let i = 1; i < sequence; i++) {
            let parse_nd = new Date(nextdate)
            if (order === 'desc') {
                dates = [[`${moment(parse_nd).subtract(3, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`, `${moment(parse_nd).subtract(5, "months").startOf('month').format("MM-DD-YYYY")} 00:00:01`], ...dates]
                nextdate = `${moment(parse_nd).subtract(3, "months").format("MM-DD-YYYY")}`
            } else {
                dates = [...dates, [`${moment(parse_nd).add(2, "days").startOf('month').format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).add(3, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`]]
                nextdate = `${moment(parse_nd).add(3, "months").format("MM-DD-YYYY")} 23:59:59`
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            let nd2 = new Date(d[1])
            return [`${moment(nd1).format("MMM D, YY")}`, `to`, ` ${moment(nd2).format("MMM D, YY")}` ]
        })
        
    } else if (interval === 'yearly') {
        let nd = new Date(date)
        dates = [[moment(nd).format('[01-01]-YYYY [00:00:01]'), moment(nd).format('[12-31]-YYYY [23:59:59]')]]
        let nyear = moment(nd)
        for (let i = 1; i < sequence; i++) {
            let parse_ny = new Date(nyear)
            if (order === 'desc') {
                let m = moment(parse_ny).subtract(1, 'year')
                dates = [[moment(m).format('[01-01]-YYYY [00:00:01]'), moment(m).format('[12-31]-YYYY [23:59:59]')], ...dates]
                nyear = moment(m).format('[01-01]-YYYY')
            } else {
                let m = moment(parse_ny).add(1, 'year')
                dates = [...dates, [moment(m).format('[01-01]-YYYY [00:00:01]'), moment(m).format('[12-31]-YYYY [23:59:59]')]]
                nyear = moment(m).format('[01-01]-YYYY')
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            return [`Year`, `of`, `${moment(nd1).format("YYYY")}`]
        })
    }

    const firstStart = dates[0][0];
    const lastEnd = dates[dates.length - 1][1]; 

    // graphDatasets.set((prev) => ({...prev, 
    //     label:datasets.label,
    //     dates:dates, 
    //     start_date:firstStart,
    //     last_date:lastEnd
    // }))
    
    // console.log(dates);
    // console.log(JSON.stringify(dates));

    return {
        label:datasets.label,
        dates:dates, 
        start_date:firstStart,
        last_date:lastEnd
    }
}

